<template>
  <div>
    <div class="w-full">
      <UForm ref="formRef" :validate="validateForm" :state="form" class="no-ring-form" @submit="onSubmit" :validate-on="['submit']">
        <div class="pt-6">

          <FormName v-model="form.name" class="w-full"/>

          <FormEmail ref="formEmailRef" v-model="form.email" class="w-full pt-4"/>

          <UFormGroup :label="$t('form.register.dob')"
                      class="!mb-6 pt-4"
                      name="birthday"
                      required>
            <template #default="{ error }">
              <UInput v-model="form.birthday"
                      :class="error ? 'border border-red rounded-md' : ''"
                      :placeholder="$t('form.register.dob')"
                      class="!mt-2 "
                      size="lg"
                      type="date"
                      max="9999-12-31"
              />
            </template>
          </UFormGroup>

          <UFormGroup name="checkbox">
            <UCheckbox v-model="form.checkbox"
                       :ui="{label: 'text-neutral-500 font-normal'}"
                       input-class="h-5 w-5 rounded-md border border-neutral-300">
                      <template #label>
                        <div>
                          <p>{{ $t('form.register.optin') }}
                            <span v-show="!readMore"
                                  class="cursor-pointer underline inline-block"
                                  v-text="t('common.learn_more')"
                                  @click.once="readMore = true" />
                          </p>
                          <p v-cloak
                             v-show="readMore"
                             class="pt-3"
                             v-text="t('form.register.optin.readmore', ['3cket'])" />
                        </div>
                      </template>
            </UCheckbox>
          </UFormGroup>

        </div>

        <div class="text-xs text-center text-neutral-500 leading-5 pt-6 pb-4">
          <i18n-t keypath="form.register.terms" scope="global" tag="div">
            <a class="cursor-pointer text-neutral-700 underline" :href="$t('common.process.terms.terms_link')" target="_blank">{{ $t('form.register.terms.terms') }}</a>
            <a class="cursor-pointer text-neutral-700 underline" :href="$t('common.process.terms.policy_link')" target="_blank">{{ $t('form.register.terms.policy') }}</a>
          </i18n-t>
        </div>

        <BaseButton :disabled="modelValue.loading" :loading="modelValue.loading" class="md:!w-full" >
          <span>{{ $t('common.continue') }}</span>
        </BaseButton>

        <p v-if="modelValue.error" class="mt-2 text-red text-sm">{{ $t(modelValue.error) }}</p>

      </UForm>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type {FormError, FormSubmitEvent} from "#ui/types"
import {useAccountStore} from "~/store/account"

const emit = defineEmits(['pin_invalid', 'continue'])

const {t} = useI18n()
const readMore = ref(false)
const loading = ref(false)
const error = ref<string>('')
const account = useAccountStore()
const formEmailRef = ref();
const formRef = ref();

const modelValue = useAttrs().modelValue as ModalModel
modelValue.icon="mini-logo"
modelValue.title="modal.phone.title"
modelValue.subtitle="modal.register.subtitle"
modelValue.icon_classes="w-9 h-5"
modelValue.icon_wrapper_classes="w-20 h-12"

const schema = useSchemaMerger([useNameSchema(), useEmailSchema(), useBirthdaySchema(), useCheckboxSchema()]);

const form = reactive<RegisterAccountForm>({
  name: undefined,
  email: undefined,
  birthday: undefined,
  checkbox: false
})

const {locale: activeLocale} = useI18n()

const validateForm = async (state?: any): Promise<FormError[]> => {
  let errors = [] as FormError[];
  formRef.value?.setErrors(errors);

  if(state) {
    errors = await useValidateFormState(schema, state)
  }

  formRef.value?.setErrors(errors);
  return errors
}

async function onSubmit(event: FormSubmitEvent<any>) {
  modelValue.loading = true

  const result = await account.registerUser(activeLocale.value, event.data)

  if (isNuxtError(result)) {
    if (result.statusMessage === 'pin_invalid') return emit('pin_invalid')

    modelValue.error = result.statusMessage as string
    modelValue.loading = false;
  }

  return emit('continue')
}
</script>
<style>
</style>
